import { Icon20CloudOutline, Icon20PicturePlusOutline } from '@vkontakte/icons';
import classNames from 'clsx';
import React, { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { addItemsFromCloudToAlbumRequest } from 'reactApp/modules/albums/albums.actions';
import { selectItemsFromCloudToVigboAlbum } from 'reactApp/modules/vigbo/vigbo.module';
import styles from 'reactApp/ui/EmptyFolder/EmptyFolder.css';
import type { FolderStorageFlags } from 'reactApp/ui/EmptyFolder/EmptyFolder.types';

export const useSelectFromCloud = (id: string, folderStorageFlags: FolderStorageFlags) => {
    const { isAlbums, isVigbo } = folderStorageFlags;

    const dispatch = useDispatch();

    const Create = useMemo(
        () => (
            <div className={styles.icon}>
                <Icon20CloudOutline />
            </div>
        ),
        []
    );

    const aditionalContent = useMemo(
        () => (
            <div className={styles.saveInCloudAditional}>
                <div className={classNames(styles.saveInCloudAditionalIcon, styles.backgroudWhite)}>
                    <Icon20PicturePlusOutline />
                </div>
                <div className={classNames(styles.saveInCloudAditionalText, styles.backgroudWhite)}>Добавить в альбом</div>
            </div>
        ),
        []
    );

    const handleClickCreateNew = useCallback(() => {
        if (isAlbums) {
            dispatch(addItemsFromCloudToAlbumRequest({ id }));
        } else if (isVigbo) {
            dispatch(selectItemsFromCloudToVigboAlbum({ albumId: id }));
        }
    }, [id, isAlbums, isVigbo]);

    let annotation: string = 'Добавьте фото и видео, уже загруженные в Облако';
    if (isAlbums) {
        annotation = 'Добавьте в альбом фото и видео, уже загруженные в Облако';
    } else if (isVigbo) {
        annotation = 'Добавьте в галерею файлы, уже загруженные в Облако';
    }

    return useCallback(() => {
        return {
            title: 'Выбрать из Облака',
            annotation,
            onClick: handleClickCreateNew,
            Icon: Create,
            additionLinks: isAlbums ? aditionalContent : undefined,
        };
    }, [Create, handleClickCreateNew]);
};
